import { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import {
	selectIsAuthenticated,
	checkTokenExpiration,
} from "./store/slices/authSlice";
import { routes } from "./routes";
import { PRIVATE_ROUTES, PUBLIC_ROUTES } from "./config/routes";
import "./styles";

const App = () => {
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const dispatch = useDispatch();

	useEffect(() => {
		dispatch(checkTokenExpiration());
	}, [dispatch]);

	return (
		<Router>
			<Routes>
				{routes.map((route, index) => (
					<Route key={index} path={route.path} element={route.element} />
				))}
				<Route
					path="*"
					element={
						<Navigate
							to={isAuthenticated ? PRIVATE_ROUTES.LOGS : PUBLIC_ROUTES.LOGIN}
							replace
						/>
					}
				/>
			</Routes>
		</Router>
	);
};

export default App;
